import { useQuery } from '@tanstack/react-query';
import { VoicesAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const voicesAPI = new VoicesAPI(axios);

export const useVoices = (connectorIdn: string) => {
    return useQuery({
        queryKey: ['voices', connectorIdn],
        queryFn: async () => voicesAPI.getVoices(connectorIdn)
    });
};
